import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const Diagram = ({ data }) => {
  if (!data || data.length === 0) {
    return <p className="text-center text-gray-500">Tidak ada data untuk ditampilkan.</p>;
  }
  return (
    <div className="w-full h-96">
      <ResponsiveContainer>
        <BarChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="nama" />
          <YAxis tickFormatter={(value) => `Rp${(value/1000).toFixed(0)}k`} />
          <Tooltip formatter={(value) => `Rp ${value.toLocaleString()}`} />
          <Legend />
          <Bar dataKey="iuranBulanan" fill="#8884d8" name="Iuran Bulanan" />
          <Bar dataKey="iuranIDI" fill="#82ca9d" name="IDI" />
          <Bar dataKey="iuranGasibu" fill="#f59e0b" name="Gasibu/Sumatera/Dll" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default Diagram;